import type { TextStyle } from "react-native";

import { Text } from "../../../../../../../../mads";
import { MarkupComponents } from "../../../../../../../../shared/components/MarkupComponents/MarkupComponents";

import React from "react";

const attributeTextStyle: TextStyle = {
  fontWeight: "bold",
};

const AttributeText = (children: string) => {
  return <Text sx={attributeTextStyle}>{children}</Text>;
};

export const QuestionText: React.FC<{
  sx?: TextStyle;
  children: string;
}> = ({ children }) => {
  if (children === undefined) {
    return null;
  }
  return (
    <MarkupComponents
      components={{
        attribute: AttributeText,
      }}
    >
      {children}
    </MarkupComponents>
  );
};
